import { VIEWPORTS } from '../context/DimensionsContext';
export const mobileContent = (props, breakpoint = VIEWPORTS.DESKTOP) => {
    return {
        [`@media (max-width: ${breakpoint}px)`]: Object.assign({}, props)
    };
};
//# sourceMappingURL=mixins.js.map